import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ICreateChallengeClipRequest } from './create-challenge-clip-request';
import type { ICreateChallengeClipResponse } from './create-challenge-clip-response';
import { createChallengeClipResponseSchema } from './create-challenge-clip-response';

export async function createChallengeClipApi({
  challengeId,
  body,
}: ICreateChallengeClipRequest): Promise<IValidatedResponse<ICreateChallengeClipResponse>> {
  return postRequest<ICreateChallengeClipResponse>({
    path: `/sys/challenges/${challengeId}/clips`,
    body,
    schema: createChallengeClipResponseSchema,
  });
}
